export default __webpack_public_path__ + "static/media/Dylan.1b7ca0e3.jpg";